import './Card.scss';

import React from 'react';
import { isMobile } from 'react-device-detect';
import { Link } from 'react-router-dom';

import { ContinueButton } from '../buttons/Buttons';

const HomeCard = ({ title, description, imgSrc, altText, footerText, linkTo }) => {
  return (
    <Link to={linkTo} className="wizard-link">
      <div className="wizard-container">
        <div className="card-top">
          <div className="card-top-text">
            <h1>
              <strong>{title}</strong>
            </h1>
            <p>{description}</p>
          </div>
          {isMobile && <img src={imgSrc} alt={altText} className="card-img" />}
        </div>
        <div className="card-footer">
          <p>{footerText}</p>
          <div className="financiar-btn">
            {!isMobile && <img src={imgSrc} alt={altText} className="card-img" />}
            {/* <button className="continue-btn">CONTINUAR</button> */}
            <ContinueButton />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default HomeCard;
